var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",class:{'is-locked': _vm.locked}},[(!_vm.loading)?[_vm._t("default")]:_vm._e(),(_vm.loading)?_c('app-icon',{staticClass:"page-loading",attrs:{"icon":"loading"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }